import styled from 'styled-components'

import commonCss from '~/core/css'

const CommonContainer = styled.div`
  margin: auto;
  max-width: 500px;
`

export const DownloadContainer = styled(CommonContainer)`
  color: ${props => props.theme.textSecondaryColor};
  font-family: sans-serif;
  font-size: ${({ theme }) => theme._neo.body01.fontSize};
  padding: 32px 0;

  & > * + *:before {
    content: '';
    border: 1px solid ${props => props.theme.colorDelimiter};
    display: block;
    margin: 32px 0;
  }
`

export const DownloadDate = styled.div`
  line-height: 24px;
`

export const DownloadFooter = styled.div`
  text-align: center;
`

export const DownloadFooterLine = styled.a.attrs(props => ({
  ...props,
  href: 'https://8x8.vc',
  target: '_blank'
}))`
  align-items: center;
  color: inherit;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  text-decoration: none;

  & > * + * {
    margin-left: 8px;
  }
`

export const DownloadInterval = styled.div`
  line-height: 24px;
`

export const DownloadTitle = styled.div`
  ${({ theme }) => ({ ...theme._neo.heading01 })}
`

export const TranscriptContainer = styled.div`
  max-width: 340px;
`

export const TranscriptPhrasesList = styled.ul`
  ${commonCss.resetBoxProps}
  list-style-type: none;
  overflow-y: auto;
`

export const TranscriptItem = styled.li`
  margin: 0 8px 16px;
`
